import styled from 'styled-components'
import Radio from '@components/Radio'

export const StyledRadio = styled(Radio.Group)`
  label {
    padding-top: ${({ theme }) => theme.space.lg};
    padding-bottom: ${({ theme }) => theme.space.lg};
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    display: none;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    svg {
      display: flex;
      margin-right: ${({ theme }) => theme.space.xs};
    }
  }
`
